/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

function _getScrollableParents(element) {
  const REGEXP_SCROLL_PARENT = /^(visible|hidden)/
  const elements = []

  if (!(element instanceof HTMLElement) || typeof window.getComputedStyle !== 'function') {
    return elements
  }

  let currenElement = element
  while (currenElement.parentNode) {
    elements.push(currenElement.parentNode)
    currenElement = currenElement.parentNode
  }

  return elements
    .filter(el => el.scrollHeight >= el.clientHeight && !REGEXP_SCROLL_PARENT.test(window.getComputedStyle(el).overflowY || 'visible'))
    .concat([document.body])
}

export function getScrollPositions(element) {
  return _getScrollableParents(element).map(node => ({
    x: node.scrollLeft,
    y: node.scrollTop,
    node,
  }))
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-base/lui-dom-helpers.js
// module id = 8
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38